import { connect } from 'react-redux';
import { getIsFavourite } from '../../../../CollectionPanel/redux/selectors';
import { getHasCommentedOnDeviation } from '../../../../redux/deviations/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return {
        isFaved: getIsFavourite(state, deviation),
        hasCommentedOn: getHasCommentedOnDeviation(state, deviation),
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=Overlay.container.js.map